import { z } from 'zod/v4';

/**
 * `PATCH /api/audits/bulk-archive` body: the audit ids to archive for the
 * caller. Same shape as the legacy `PATCH /v1/audits/bulk-archive` — a bare
 * array, at least one non-empty id.
 */
export const BulkArchiveAuditsBodySchema = z.array(z.string().min(1)).min(1);

export type BulkArchiveAuditsBody = z.infer<typeof BulkArchiveAuditsBodySchema>;

/**
 * The ids actually archived: the requested ones that are audits shared with
 * the caller and whose grant was archived. Ids the caller cannot see are left
 * out rather than rejected, as before. The legacy route answered
 * `{ message: 'Done' }`, which no caller read.
 */
export const BulkArchiveAuditsResponseSchema = z.object({
  archivedIds: z.array(z.string()),
});

export type BulkArchiveAuditsResponse = z.infer<
  typeof BulkArchiveAuditsResponseSchema
>;

/**
 * `PATCH /api/audits/bulk-unarchive` body — same shape as bulk-archive. Same as
 * the legacy `PATCH /v1/audits/bulk-unarchive`.
 */
export const BulkUnarchiveAuditsBodySchema = BulkArchiveAuditsBodySchema;

export type BulkUnarchiveAuditsBody = BulkArchiveAuditsBody;

/**
 * The ids actually unarchived: the requested ones that are audits shared with
 * the caller and whose grant was reactivated. The legacy route answered
 * `{ message: 'Done' }`, which no caller read.
 */
export const BulkUnarchiveAuditsResponseSchema = z.object({
  unarchivedIds: z.array(z.string()),
});

export type BulkUnarchiveAuditsResponse = z.infer<
  typeof BulkUnarchiveAuditsResponseSchema
>;
